/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Return the last (non-trailing slash) part of the URL.
 * @export
 * @returns {string} Return the last (non-trailing slash) part of the URL. If not applicable, return an empty string.
 */
export const getSlug = (): string => {
  let { pathname: url } = location;

  // Drop trailing slash
  if (url[url.length - 1] === `/`) {
    url = url.slice(0, url.length - 1);
  }

  const urlParts = url.split('/');

  if (urlParts.length < 2) {
    return ``;
  }

  return urlParts[urlParts.length - 1];
};
